import Vue from "vue";
import GoTrue, { User } from "gotrue-js";

export default Vue.extend({
  computed: {
    $user: {
      get(): User | null {
        return (this.$root as any).user;
      },
      set(user: User) {
        (this.$root as any).user = user;
      },
    },
    $userToken(): string {
      const token = this.$user?.token.access_token || null;
      return token;
    },
    $userConfirmed(): boolean {
      return !!this.$user?.confirmed_at || false;
    },
    $auth(): GoTrue {
      return (this.$root as any).auth;
    },
  },
});
